import React from "react";
import { Range } from "react-range";
import { numberWithCommas } from "../../utils/application-helper";

const RangeSlider = ({ values, min, max, step, onChange }) => {
  return (
    <div className="range-slider">
      <Range
        values={values}
        step={step}
        min={min}
        max={max}
        onChange={onChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "10px",
              width: "100%",
              background: `linear-gradient(
                  to right, 
                  white ${((values[0] - min) / (max - min)) * 100}%,
                  rgb(48, 50, 146) ${((values[0] - min) / (max - min)) * 100}%,
                  rgb(48, 50, 146) ${((values[1] - min) / (max - min)) * 100}%,
                  white ${((values[1] - min) / (max - min)) * 100}%
                )`,
              border: "2px solid rgb(48, 50, 146)",
              borderRadius: "0",
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            {...props}
            key={props.key}
            style={{
              ...props.style,
              height: "20px",
              width: "20px",
              backgroundColor: "white",
              borderRadius: "50%",
              border: "4px solid rgb(48, 50, 146)",
              boxShadow: isDragged ? "0 0 5px #aaa" : "none",
            }}
          />
        )}
      />
      <div className="search-bottom-wrapper">
        <p>Rs.{numberWithCommas(min)}</p>
        <p>Rs.{numberWithCommas(max)}</p>
      </div>
    </div>
  );
};

export default RangeSlider;
